export default __webpack_public_path__ + "static/media/correct.a8d20cd4.png";